export function SourceChip({ type, children, testid }) {
    // type: "external" | "internal" | "ai" | "doc"
    const cls =
        type === "external"
            ? "chip chip-external"
            : type === "internal"
              ? "chip chip-internal"
              : type === "doc"
                ? "chip chip-doc"
                : "chip chip-ai";
    return (
        <span data-testid={testid} className={cls}>
            {children}
        </span>
    );
}

export function AIAssistBanner({ label = "AI-assisted. Advocate review required before filing." }) {
    return (
        <div
            data-testid="ai-assist-banner"
            className="chip chip-ai w-full justify-center py-2 text-[11px] tracking-wide uppercase font-semibold"
        >
            ⚖ {label}
        </div>
    );
}
